export type LiveNotification = {
  kind?: string;
  sessionId: string; displayName: string; status: string; requestedAt: string;
  readAt: string | null; unread: boolean; canOpen: boolean;
};
export type LiveNotifications = { items: LiveNotification[]; unreadCount: number };
export const emptyNotifications: LiveNotifications = { items: [], unreadCount: 0 };

// The OS permission is deliberately not involved in database/bell reconciliation.
export function claimAlert(storage: Pick<Storage, "getItem" | "setItem">, scope: string, id: string, now: number) {
  const key = `live-chat-alerts:${scope}`;
  try {
    const saved = JSON.parse(storage.getItem(key) || "{}") as Record<string, number>;
    if (saved[id]) return false;
    const recent = Object.entries(saved).filter(([, time]) => now - time < 86400000).slice(-200);
    storage.setItem(key, JSON.stringify({ ...Object.fromEntries(recent), [id]: now }));
    return true;
  } catch {
    // If deduplication cannot be guaranteed, skip optional alerts, never the bell.
    return false;
  }
}
